export default () => {
	return {
		tilePlaceHolder: {
			width: 150,
			height: 150,
			display: "flex",
			minHeight: 150,
			margin: "auto",
			borderRadius: 200,
			border: "5px solid #ececec",
			backgroundColor: "whitesmoke",
		},
		paceJoinMeetingPage: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "flex-start",
			minHeight: "100%",
			maxWidth: "75%",
			padding: "4rem 2rem",
			textAlign: "center",
			margin: "auto",
		},
		paceMeetingLayout: {
			height: "100%",
			width: "100%",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		meetingControls: {
			bottom: 10,
			display: "flex",
			justifyContent: "center",
			position: "absolute",
		},
		paceMeetingTileContent: {
			position: "relative",
			gridArea: "content",
			height: "100%",
			width: "100%",
			display: "flex",
			flexDirection: "column",
		},
	};
};
